<script>

    import { toast } from 'bulma-toast'
    import { userStore, modalStore } from '../stores'

    import StorageService from '../$services/storage.service'
    import UsersService from '../$services/users.service'

    import Spinner from '../$components/spinner.svelte'
    import Switch from '../$components/switch.svelte'
    import Button from '../$components/button.svelte'

    let loading = false
    let data = {
        sendEmailDeliveryPickup: $userStore.sendEmailDeliveryPickup,
        sendEmailDeliveryDelivery: $userStore.sendEmailDeliveryDelivery,
    }

    async function updateUser() {

        loading = true
        const resp = await UsersService.updateUser(data)
        loading = false

        if(!resp.success)
            return toast({message: resp.error.message, type: 'is-danger'})

        StorageService.setItem('user', resp.data)
        userStore.set(resp.data)

        toast({message: 'Información actualizada', type: 'is-success'})
        modalStore.close()
    }

</script>

<Spinner {loading} />

{#if !loading}
    <form on:submit|preventDefault={updateUser}>
        <div class="columns">
            <div class="column">
                <Switch bind:checked={ data.sendEmailDeliveryPickup } label="Enviar correo de entrega al remitente" />
            </div>
        </div>
        <div class="columns">
            <div class="column">
                <Switch bind:checked={ data.sendEmailDeliveryDelivery } label="Enviar correo de entrega al destinatario" />
            </div>
        </div>
        <div class="items-end">
            <div class="buttons">
                <Button on:click={() => modalStore.set(null)} type="button" text="Cancelar" icon="ban" />
                <Button on:click={ updateUser } type="submit" text="Guardar" icon="save" color="primary" />
            </div>
        </div>
    </form>
{/if}